const COLD_START_SECONDS = 23.2;
const PAGE_SECONDS = 16.84;
const RECEPTACLE_DETECTION_SECONDS = 0.193;

const toWholeSeconds = (seconds: number) => Math.max(0, Math.round(seconds));

export const estimatePageOnlySeconds = (pageCount: number) =>
  toWholeSeconds(COLD_START_SECONDS + PAGE_SECONDS * Math.max(0, pageCount));

export const estimateReceptacleSeconds = (pageCount: number, detectionCount: number) =>
  toWholeSeconds(
    COLD_START_SECONDS +
      PAGE_SECONDS * Math.max(0, pageCount) +
      RECEPTACLE_DETECTION_SECONDS * Math.max(0, detectionCount)
  );
